/**
 * The Mutation types
 * @type String
 */

export const SET_PRODUCT_ENTRY = 'set-product-entry'
export const RESET_PRODUCT_ENTRY = 'reset-product-entry'
export const COMPLETE_STEP = 'complete-step';
export const RESET_STEPS = 'reset-steps';

/**
 * The Mutations
 * @type { Object }
 */
export default {
	[SET_PRODUCT_ENTRY]: (state, { entry, fields }) => {
		state.product[entry] = fields
	},

	[RESET_PRODUCT_ENTRY]: (state, { entry }) => {
		entry.forEach(element => {
			if (typeof state.product[element] === 'object') {
				for (let key in state.product[element]) {
					state.product[element][key] = null;
				}
			} else {
				state.product[element] = null;
			}
		})
	},

	[COMPLETE_STEP]: (state, { step }) => {
		state.steps[step] = true;
	},

	[RESET_STEPS]: (state, { steps }) => {
		steps.forEach(element => { state.steps[element] = false })
	},
};


// WEBPACK FOOTER //
// ./src/store/product/mutations.js